import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import { NumericFormat } from "react-number-format";

const Capnhatbenxekhach = React.memo(function Capnhatbenxekhach(props) {
  const { thang } = props;
  const [thangnam, setThangnam] = React.useState(null);
  const [sodonvi, setSodonvi] = React.useState(0);
  const [sotuyen_noitinh, setSotuyen_noitinh] = React.useState(0);
  const [sotuyen_lientinh, setSotuyen_lientinh] = React.useState(0);
  const [sotuyen_buyt, setSotuyen_buyt] = React.useState(0);
  const [sophuongtien_noitinh, setSophuongtien_noitinh] = React.useState(0);
  const [sophuongtien_lientinh, setSophuongtien_lientinh] = React.useState(0);
  const [sophuongtien_buyt, setSophuongtien_buyt] = React.useState(0);
  const [sochuyen_noitinh_th, setSochuyen_noitinh_th] = React.useState(0);
  const [sochuyen_noitinh_kh, setSochuyen_noitinh_kh] = React.useState(0);
  const [sochuyen_lientinh_th, setSochuyen_lientinh_th] = React.useState(0);
  const [sochuyen_lientinh_kh, setSochuyen_lientinh_kh] = React.useState(0);
  const [sochuyen_buyt_th, setSochuyen_buyt_th] = React.useState(0);
  const [sochuyen_noitinh_kth, setSochuyen_noitinh_kth] = React.useState(0);
  const [sochuyen_lientinh_kth, setSochuyen_lientinh_kth] = React.useState(0);
  const [sokhach_vanchuyen, setSokhach_vanchuyen] = React.useState(0);
  const [congsuat_thucte, setCongsuat_thucte] = React.useState(0);
  const [congsuat_congbo, setCongsuat_congbo] = React.useState(0);
  const [ghichu_baocao, setGhichu_baocao] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getthongtin = () => {
    var url =
      Config.backend +
      "/api/Donvi/getslthbenxekhachthang?thang=" +
      thang +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setSodonvi(data[0].sodonvi);
        setSotuyen_noitinh(data[0].sotuyen_noitinh);
        setSotuyen_lientinh(data[0].sotuyen_lientinh);
        setSotuyen_buyt(data[0].sotuyen_buyt);
        setSophuongtien_noitinh(data[0].sophuongtien_noitinh);
        setSophuongtien_lientinh(data[0].sophuongtien_lientinh);
        setSophuongtien_buyt(data[0].sophuongtien_buyt);
        setSochuyen_noitinh_th(data[0].sochuyen_noitinh_th);
        setSochuyen_noitinh_kh(data[0].sochuyen_noitinh_kh);
        setSochuyen_lientinh_th(data[0].sochuyen_lientinh_th);
        setSochuyen_lientinh_kh(data[0].sochuyen_lientinh_kh);
        setSochuyen_buyt_th(data[0].sochuyen_buyt_th);
        setSochuyen_noitinh_kth(data[0].sochuyen_noitinh_kth);
        setSochuyen_lientinh_kth(data[0].sochuyen_lientinh_kth);
        setSokhach_vanchuyen(data[0].sokhach_vanchuyen);
        setCongsuat_thucte(data[0].congsuat_thucte);
        setCongsuat_congbo(data[0].congsuat_congbo);
        setGhichu_baocao(data[0].ghichu_baocao);
        let [month, year] = data[0].thang.split("/");
        setThangnam(dayjs(year + "-" + month));
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhat = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url = Config.backend + "/api/Phuongtien/themslthbenxekhach";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        thang: thang,
        sodonvi: sodonvi,
        sotuyen_noitinh: sotuyen_noitinh,
        sotuyen_lientinh: sotuyen_lientinh,
        sotuyen_buyt: sotuyen_buyt,
        sophuongtien_noitinh: sophuongtien_noitinh,
        sophuongtien_lientinh: sophuongtien_lientinh,
        sophuongtien_buyt: sophuongtien_buyt,
        sochuyen_noitinh_th: sochuyen_noitinh_th,
        sochuyen_lientinh_th: sochuyen_lientinh_th,
        sochuyen_noitinh_kh: sochuyen_noitinh_kh,
        sochuyen_lientinh_kh: sochuyen_lientinh_kh,
        sochuyen_buyt_th: sochuyen_buyt_th,
        sochuyen_noitinh_kth: sochuyen_noitinh_kth,
        sochuyen_lientinh_kth: sochuyen_lientinh_kth,
        sokhach_vanchuyen: sokhach_vanchuyen,
        congsuat_thucte: congsuat_thucte,
        congsuat_congbo: congsuat_congbo,
        ghichu_baocao: ghichu_baocao,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
        } else showNotification1();
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  React.useEffect(() => {
    getthongtin();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: "5px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Tháng báo cáo"
                  value={thangnam}
                  format="MM/YYYY"
                  onChange={(newValue) => {
                    setThangnam(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 30,
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <FormControl style={{ width: "100%", marginTop: "5px" }}>
              <TextField
                label="Ghi chú báo cáo"
                variant="outlined"
                size="small"
                value={ghichu_baocao}
                onChange={(event) => {
                  setGhichu_baocao(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <NumericFormat
                label="1. Tổng số đơn vị đăng ký khai thác tại bến (đơn vị)"
                variant="outlined"
                size="small"
                value={sodonvi}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSodonvi(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <NumericFormat
                label="2. Tổng số tuyến xe xuất phát tại bến (tuyến)"
                variant="outlined"
                size="small"
                disabled={true}
                value={Number(sotuyen_noitinh) + Number(sotuyen_lientinh)}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="- Tuyến nội tỉnh"
                variant="outlined"
                size="small"
                value={sotuyen_noitinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSotuyen_noitinh(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="- Tuyến liên tỉnh"
                variant="outlined"
                size="small"
                value={sotuyen_lientinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSotuyen_lientinh(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="- Tuyến xe buýt"
                variant="outlined"
                size="small"
                value={sotuyen_buyt}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSotuyen_buyt(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="3. Số lượng phương tiện (xe)"
                variant="outlined"
                size="small"
                disabled={true}
                value={
                  Number(sophuongtien_noitinh) + Number(sophuongtien_lientinh)
                }
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="- Tuyến nội tỉnh"
                variant="outlined"
                size="small"
                value={sophuongtien_noitinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSophuongtien_noitinh(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="- Tuyến liên tỉnh"
                variant="outlined"
                size="small"
                value={sophuongtien_lientinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSophuongtien_lientinh(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="- Tuyến xe buýt"
                variant="outlined"
                size="small"
                value={sophuongtien_buyt}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSophuongtien_buyt(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="4. Tổng số chuyến xe thực hiện (chuyến)"
                variant="outlined"
                size="small"
                disabled={true}
                value={
                  Number(sochuyen_noitinh_th) + Number(sochuyen_lientinh_th)
                }
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="- Tuyến nội tỉnh TH"
                variant="outlined"
                size="small"
                value={sochuyen_noitinh_th}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSochuyen_noitinh_th(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="- Tuyến nội tỉnh KH"
                variant="outlined"
                size="small"
                value={sochuyen_noitinh_kh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSochuyen_noitinh_kh(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="- Tuyến liên tỉnh TH"
                variant="outlined"
                size="small"
                value={sochuyen_lientinh_th}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSochuyen_lientinh_th(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="- Tuyến liên tỉnh KH"
                variant="outlined"
                size="small"
                value={sochuyen_lientinh_kh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSochuyen_lientinh_kh(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="5. Tổng số chuyến xe buýt (chuyến)"
                variant="outlined"
                size="small"
                value={sochuyen_buyt_th}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSochuyen_buyt_th(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="6. Tổng số chuyến xe không thực hiện (chuyến)"
                variant="outlined"
                size="small"
                disabled={true}
                value={
                  Number(sochuyen_noitinh_kth) + Number(sochuyen_lientinh_kth)
                }
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="- Tuyến nội tỉnh"
                variant="outlined"
                size="small"
                value={sochuyen_noitinh_kth}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSochuyen_noitinh_kth(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="- Tuyến liên tỉnh"
                variant="outlined"
                size="small"
                value={sochuyen_lientinh_kth}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSochuyen_lientinh_kth(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="7. Tổng hành khách vận chuyển thông qua bến (HK)"
                variant="outlined"
                size="small"
                value={sokhach_vanchuyen}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSokhach_vanchuyen(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="Công suất bến xe thực tế"
                variant="outlined"
                size="small"
                value={congsuat_thucte}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setCongsuat_thucte(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="Công suất bến xe công bố"
                variant="outlined"
                size="small"
                value={congsuat_congbo}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setCongsuat_congbo(value);
                }}
                InputProps={{
                  style: {
                    height: 30,
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "30px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={capnhat}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Capnhatbenxekhach.propTypes = {
  thang: PropTypes.string,
};
export default Capnhatbenxekhach;
